module.exports = __webpack_public_path__ + "static/jackson-9abce81283377eb7048537db2befb17d.png";